import { ToolbarConfig, OutlineType } from '@tencent/workbench';
import { DropdownType, getFontFamilyConfigData } from '@editor/src/js/constants/toolbar-data';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_DROPDOWN } from '@editor/src/img/pageIndex';
import { wrapIdForInput, wrapIdForTableTabInput, wrapIdForTextTab } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.FONT,
    content: i18n.t('字体'),
    value: '',
    tipMsg: i18n.t('字体'),
    icon: null,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.FONT_FAMILY,
        checkSelectedValue: true,
        data: getFontFamilyConfigData(),
    },
    twdConfig: {
        action: TDWActionType.TEXT_FONT,
    },
};

export const configTheme = {
    ...config,
    id: ActionType.FONT_THEME,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        style: {
            width: 64,
            marginLeft: 4,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
    {
        name: wrapIdForInput(config.id),
        text: i18n.t('字体'),
        tooltip: config.tipMsg,
        outlineType: OutlineType.INPUT,
        style: {
            width: 133,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            marginTop: '-1px',
        },
    },
    {
        name: wrapIdForTableTabInput(config.id),
        text: i18n.t('字体'),
        tooltip: config.tipMsg,
        outlineType: OutlineType.INPUT,
        style: {
            width: 90,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            marginTop: '-1px',
        },
    },
    {
        name: wrapIdForTextTab(config.id),
        text: i18n.t('字体'),
        tooltip: config.tipMsg,
        outlineType: OutlineType.INPUT,
        style: {
            width: 90,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            marginTop: '-1px',
        },
    },
];
